// The code in this file will load on every page of your site

 import wixLocation from "wix-location";

 $w.onReady(function () {
 // Write your code here
 });

 /**
 * Adds an event handler that runs when the element is clicked.
 * @param {$w.MouseEvent} event
 */

 export function bookBtn_click(event) {
 // This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4

 // Add your code for this event here:
 wixLocation.to(wixLocation.url.replace(/(?:#.*)?$/, "#book-now"));
 }